import AxiosInstance from "../services/networkServices";

export const listThemes = async (payload) => {
  const res = await AxiosInstance.post(`/admin/theme/list`, payload);
  return res.data;
};

/**
 * Themes content can still be added to (active now or upcoming), soonest
 * first. Open to every account with the karaoke, challenges or themes
 * permission, so uploaders without the Themes page can still pick one.
 */
export const listOpenThemes = async () => {
  const res = await listThemes({
    page: 1,
    limit: 100,
    status: ["active", "upcoming"],
    sortOrder: "asc",
  });
  return res?.data?.list || [];
};

export const createTheme = async (payload) => {
  const res = await AxiosInstance.post(`/admin/theme`, payload);
  return res.data;
};

export const updateTheme = async (id, payload) => {
  const res = await AxiosInstance.put(`/admin/theme/${id}`, payload);
  return res.data;
};

/** One theme. Admin callers also get the sticker library and linked content titles. */
export const getTheme = async (id) => {
  const res = await AxiosInstance.get(`/admin/theme/${id}`);
  return res.data;
};

/** Move every linked challenge, song and dance onto the theme's current dates. */
export const syncThemeDates = async (id) => {
  const res = await AxiosInstance.post(`/admin/theme/${id}/sync-dates`, {});
  return res.data;
};

export const deleteTheme = async (id) => {
  const res = await AxiosInstance.delete(`/admin/theme/${id}`);
  return res.data;
};

export const downloadTheme = async (id) => {
  const res = await AxiosInstance.get(`/admin/theme/${id}/export`, {
    responseType: "blob",
  });
  return res;
};

export const importTheme = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await AxiosInstance.post(`/admin/theme/import`, formData);
  return res.data;
};
